import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React from 'react'

import Html from '../Html/Html'
import Popover from '../Popover/Popover'

const DivContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    '& img:first-of-type': {
      marginTop: '0px',
    },
  },
}))

const ExpenseRatio = ({ ratio, popup = [] }) => {
  let htmlContent = popup?.[0]?.html?.map((html, index) => (
    <Html key={`expense-ratio-${index}`} nowrap={true} content={html} />
  ))

  if (!htmlContent || htmlContent.length === 0) {
    htmlContent = popup?.[0]?.text?.map((text, index) => (
      <p key={`expense-ratio-${index}`}>{text}</p>
    ))
  }

  return (
    <DivContainer>
      {!ratio || ratio === '--' ? '--' : `${ratio}%`}
      {htmlContent && htmlContent.length > 0 && (
        <Popover htmlContent={htmlContent} />
      )}
    </DivContainer>
  )
}

ExpenseRatio.propTypes = {
  ratio: PropTypes.any,
  popup: PropTypes.arrayOf(
    PropTypes.shape({
      html: PropTypes.arrayOf(PropTypes.string),
      text: PropTypes.arrayOf(PropTypes.string),
    })
  ),
}

export default ExpenseRatio
